import { useLocalStorage } from '../useLocalStorage';

export const useFilterShortcut = () => {
  return useLocalStorage<boolean>('confidence-filter-shortcut-enabled', true);
};
